import React from 'react';
import SafeIcon from '../common/SafeIcon';

export default function EmptyState({ title, message, icon = "FiInbox" }) {
  return (
    <div className="flex flex-col items-center justify-center p-12 text-center h-full">
      <div className="relative mb-6">
        <div className="absolute inset-0 bg-blue-500/10 blur-3xl rounded-full" />
        <div className="relative w-20 h-20 bg-slate-900 border border-slate-800 rounded-3xl flex items-center justify-center text-slate-600 shadow-2xl">
          <SafeIcon icon={icon} className="text-4xl" />
          <div className="absolute -bottom-1 -right-1 w-6 h-6 bg-orange-500 rounded-full flex items-center justify-center text-white border-4 border-slate-900">
            <SafeIcon icon="FiPlus" className="text-[10px]" />
          </div>
        </div>
      </div>
      <h3 className="text-lg font-bold text-slate-200 mb-2">{title}</h3>
      <p className="text-sm text-slate-500 max-w-xs mx-auto leading-relaxed">
        {message}
      </p>
      <button className="mt-6 px-6 py-2 bg-slate-800 hover:bg-slate-700 text-slate-300 text-xs font-bold rounded-lg transition-all border border-slate-700 uppercase tracking-widest">
        Initialize Module
      </button>
    </div>
  );
}